module.exports = __webpack_public_path__ + "static/media/Chapter1.50a42a7f.pdf";